import React from "react";
import { Card, CardBody, CardTitle, CardText, Row, Col } from "reactstrap";
import Rating from 'ui/rating'

/**
 * ReviewBubbleCard (Reactstrap)
 * - Foto redonda
 * - Título de producto
 * - Estrellas
 * - Texto
 */
export default function ReviewCard({
  avatarUrl = "https://i.pravatar.cc/300",
  productTitle = "Sagrada Familia Small Group Tour",
  rating = 4.5, // 0..5 (puede ser decimal)
  reviewer = "María G.",
  text = "Muy buena visita a Sagrada Familia. Amable, muy simpática y explicó muy bien"
}) {

  return (
    <div style={{ maxWidth: 560 }}>
      <Card
        className="border-0 shadow-sm"
        style={{
          borderRadius: 22,
          position: "relative",
          background: "white"
        }}
      >
        {/* “Colita” de burbuja */}
        <div
          style={{
            position: "absolute",
            left: 34,
            bottom: -10,
            width: 20,
            height: 20,
            background: "white",
            transform: "rotate(45deg)",
            borderRadius: 4,
            boxShadow: "6px 6px 16px rgba(0,0,0,0.06)"
          }}
        />

        <CardBody style={{ padding: 18 }}>
          <Row className="g-3 align-items-start">
            <Col xs="auto">
              <img
                src={avatarUrl}
                alt={`Foto de ${reviewer}`}
                width={56}
                height={56}
                style={{
                  borderRadius: "999px",
                  objectFit: "cover",
                  border: "2px solid rgba(0,0,0,0.06)"
                }}
              />
            </Col>

            <Col>
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <div>
                  <CardTitle tag="h6" className="mb-1" style={{ fontWeight: 700 }}>
                    {productTitle}
                  </CardTitle>
                  <div className="text-muted" style={{ fontSize: 13 }}>
                    {reviewer}
                  </div>
                </div>

                <Rating value={5}/>
              </div>

              <CardText className="mt-3 mb-0" style={{ color: "#2b2b2b", lineHeight: 1.5 }}>
                {text}
              </CardText>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
}
